module.exports = __webpack_public_path__ + "img/whatsapp.c701997c.png";